<template>
  <b-sidebar
    id="sidebar"
    no-header
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    class="mc-sidebar-liveview mc-sidebar-route"
  >
    <div class="mc-sidebar-liveview__wrapper">
      <div class="mc-sidebar-route-planning__wrapper">
        <h4 v-if="isUpdate" class="mc-sidebar-route__title">
          {{ $t('master.list.driver.status') }}
        </h4>
        <p v-if="isUpdate">
          <span v-if="status === 'done'" class="mc-status mc-status--green">
            {{ $t('master.status.selesai') }}</span
          >
          <span v-else-if="status === 'cancelled'" class="mc-status mc-status--red">
            {{ $t('master.status.dibatalkan') }}</span
          >
          <span v-else-if="status === 'progress'" class="mc-status mc-status--blue">
            {{ $t('master.status.dalamPerjalanan') }}</span
          >
          <span v-else-if="status === 'scheduled'" class="mc-status mc-status--grey">
            {{ $t('master.status.dijadwalkan') }}</span
          >
        </p>
        <h4 class="mc-sidebar-route__title">
          {{ $t('route.routePlaning.subTitle') }}
        </h4>
        <FormulateInput
          v-model="form.vehicleId"
          type="select-resourceful"
          name="licensePlate"
          :label="$t('global.object.licensePlate')"
          :placeholder="`${$t('global.form.select')} ${$t('global.object.licensePlate')}`"
          :optionsGetter="getVehicle"
          :optionLabelFn="
            ({ item }) => {
              return item.license_plate
            }
          "
          :initialObject="initialUpdate.vehicle"
          trackBy="vehicle_id"
          validation="required"
          :disabled="isUpdate && ['done', 'cancelled', 'progress'].includes(status)"
        />

        <FormulateInput
          v-model="form.route"
          type="select-resourceful"
          name="route"
          :label="$t('master.rute')"
          class="mt-2"
          :placeholder="`${$t('global.form.select')} ${$t('master.rute')}`"
          :optionsGetter="routeApi.getSearchByName"
          :optionLabelFn="
            ({ item }) => {
              return item.name
            }
          "
          :initialObject="initialUpdate.route"
          validation="required"
          :disabled="isUpdate && ['done', 'cancelled', 'progress'].includes(status)"
        />

        <FormulateInput
          key="startOn"
          v-model="form.startOn"
          name="startOn"
          class="mt-2"
          :label="$t('route.routePlaning.list.scheduleStart')"
          :placeholder="$t('route.routePlaning.list.scheduleStart')"
          type="date-picker"
          validation="required"
          format="DD MMM YYYY HH:mm"
          datepickerType="datetime"
          valueType="YYYY-MM-DDTHH:mm:ss.SSSZ"
          :showSecond="false"
          :confirm="true"
          :cancel="true"
          :confirmText="$t('global.action.apply')"
          :disabled="isUpdate && ['done', 'cancelled', 'progress'].includes(status)"
        />

        <FormulateInput
          key="expectedEndTime"
          v-model="form.estimatedEndTime"
          name="expectedEndTime"
          class="mt-2"
          :label="$t('global.estimate') + ' ' + $t('route.routePlaning.list.scheduleEnd')"
          :placeholder="$t('global.estimate') + ' ' + $t('route.routePlaning.list.scheduleEnd')"
          type="date-picker"
          validation="required"
          format="DD MMM YYYY HH:mm"
          datepickerType="datetime"
          valueType="YYYY-MM-DDTHH:mm:ss.SSSZ"
          :disabled="true"
          :tooltip="$t('route.routePlaning.expectedEndTooltip')"
        />

        <div
          v-if="!isUpdate || !['done', 'cancelled', 'progress'].includes(status)"
          class="mc-sidebar-route__monitoring"
        >
          <h4 class="mc-sidebar-route__title">
            {{ $t('route.routePlaning.planOther') }}
            <span v-b-tooltip.hover.lefttop="$t('route.tooltipListOtherPlaning')">
              <i class="mc-fa icon-outline_info"></i>
            </span>
          </h4>
          <div>
            <b-button
              v-b-modal.modal-route-planing
              :variant="$store.state.map.modalRoutePlanning ? 'primary' : 'outline-primary'"
              class="w-100 text-start mb-2"
              :disabled="isDisableVehicle"
              @click="$store.commit('map/MODAL_ROUTEPLANNING', true)"
            >
              <i class="mc-fa icon-outline_pin-history"></i> {{ $t('route.routeList') }}
            </b-button>
            <b-button
              v-b-modal.modal-fleet-planing
              :variant="$store.state.map.modalFleetPlanning ? 'primary' : 'outline-primary'"
              class="w-100 text-start"
              :disabled="isDisableRoute"
              @click="$store.commit('map/MODAL_FLEETPLANNING', true)"
            >
              <i class="mc-fa icon-outline_car"></i> {{ $t('global.object.fleetList') }}
            </b-button>
          </div>
        </div>
      </div>
      <ModalRoute v-if="form.vehicleId" :vehicleId="form.vehicleId" />
      <ModalFleet v-if="form.route" :route="form.route" />
    </div>
  </b-sidebar>
</template>

<script>
import responsive from '@/mixin/responsive'
import ModalRoute from '../Modal/ModalRoute'
import ModalFleet from '../Modal/ModalFleet'
import { GET_ROUTE_RECORD } from '@/services/api/route/index.js'
import { getAvailableVehicleByRoutePlanning } from '@/services/rest-api/lib/route/vehicle'
import * as routeApi from '@/services/rest-api-vsms/lib/route/route'
import { Helper } from '@/mixin/helper.js'
import { MixPanel } from '@/mixin/mixpanel'
import moment from 'moment'

export default {
  name: 'SideBarPlaning',
  components: {
    ModalRoute,
    ModalFleet,
  },
  mixins: [responsive, Helper, MixPanel],
  apollo: {
    routeRecord: {
      query: GET_ROUTE_RECORD,
      fetchPolicy: 'no-cache',
      manual: true,
      variables() {
        return {
          filter: {
            routeRecordId: Number(this.$route.params.routeRecordId),
          },
        }
      },
      skip() {
        return !this.$route.params.routeRecordId
      },
      result({ data, loading }) {
        if (!loading) {
          if (data.routeRecord.isSuccessful) {
            const routeRecord = data.routeRecord.routeRecord
            this.initialUpdate = {
              vehicle: {
                vehicle_id: routeRecord.vehicle.id,
                license_plate: routeRecord.vehicle.licensePlate,
              },
              route: {
                id: routeRecord.route.routeId,
                name: routeRecord.route.name,
              },
            }

            this.form = {
              vehicleId: routeRecord.vehicle.id,
              route: routeRecord.route.routeId,
              startOn: moment(routeRecord.expectedStartOn).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              estimatedEndTime: moment(routeRecord.expectedEndOn).format(
                'YYYY-MM-DDTHH:mm:ss.SSSZ'
              ),
            }

            this.status = routeRecord.status
            this.startOn = routeRecord.startOn
            this.$emit('updateStatus', this.status)
            this.track('View Detail Route Planning')
          } else {
            this.$mcToast.warning(data.routeRecord.message)
          }
        }
      },
    },
  },
  data() {
    return {
      otherPlaning: false,

      refetch: true,
      result: {},
      routeData: {},

      routeApi: routeApi,

      form: {
        vehicleId: null,
        route: null,
        startOn: null,
        estimatedEndTime: null,
      },
      status: '',

      isUpdate: false,
      initialUpdate: {
        vehicle: {},
        route: {},
      },

      openFleet: false,
      openRoute: false,
      handlerModal: null,
      startOn: null,
    }
  },
  computed: {
    isDisableVehicle() {
      if (this.form.vehicleId) return false
      return true
    },
    isDisableRoute() {
      if (this.form.route) return false
      return true
    },
    getVehicle() {
      return async (params) => {
        const result = await getAvailableVehicleByRoutePlanning(params)
        return result
      }
    },
  },

  watch: {
    'form.route': {
      async handler(val) {
        let params = null
        if (['progress', 'done', 'cancelled'].includes(this.status) && this.startOn) {
          params = {
            source: 'archived',
            limit: this.startOn,
          }
        }

        const route = await routeApi.show(val, params)
        route.data.startOn = this.startOn
        route.data.routeRecordStatus = this.status
        this.$emit('onGetRoute', route)
        this.routeData = { ...route.data }

        if (this.form.startOn) {
          this.setEta()
        }
      },
      deep: true,
    },
    'form.startOn': {
      handler(val) {
        if (val) {
          this.setEta()
        }
      },
      deep: true,
    },
  },

  created() {
    if (this.$route.params.routeRecordId) {
      this.isUpdate = true
    }
  },

  methods: {
    disabledDate(date) {
      return new Date(date.setDate(date.getDate() + 1)) - 1 < new Date()
    },

    setEta() {
      if (Object.keys(this.routeData).length) {
        const eta_time = this.routeData?.route_plan.find((x) => x.priority === 0).eta_time
        this.form.estimatedEndTime = this.momentAdd(this.form.startOn, eta_time, 's').format(
          'YYYY-MM-DDTHH:mm:ss.SSSZ'
        )
      }
    },
  },
}
</script>
